"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichContentSemantic = void 0;
const react_1 = __importDefault(require("react"));
const rich_content_element_1 = require("../rich-content-element");
const styles_1 = require("./styles");
const types_1 = require("./types");
const SEMANTIC_ATTRIBUTES_TAG = {
    [types_1.SemanticAttributes.strong]: 'strong',
    [types_1.SemanticAttributes.emphasized]: 'em',
    [types_1.SemanticAttributes.small]: 'small',
    [types_1.SemanticAttributes.subscript]: 'sub',
    [types_1.SemanticAttributes.superscript]: 'sup',
    [types_1.SemanticAttributes.underlined]: 'u',
    [types_1.SemanticAttributes.quoted]: 'q'
};
const RichContentSemantic = ({ path = 'root', children, bold, italic, color, fontSize }) => {
    var _a, _b;
    if (!(children === null || children === void 0 ? void 0 : children.content)) {
        return null;
    }
    try {
        const shouldApplyBold = bold || children['strong'] === true || children['strong'] === 'true';
        const shouldBeItalic = italic ||
            children['quoted'] === true ||
            children['quoted'] === 'true' ||
            children['emphasized'] === true ||
            children['emphasized'] === 'true';
        if (children['superscript'] === true || (children['superscript'] === 'true' && ((_a = children.content) === null || _a === void 0 ? void 0 : _a.text))) {
            return (react_1.default.createElement(styles_1.StyledSup, { style: shouldApplyBold ? { fontWeight: 'bold' } : { fontWeight: 'normal' } }, children.content.text));
        }
        if (children['subscript'] === true || (children['subscript'] === 'true' && ((_b = children.content) === null || _b === void 0 ? void 0 : _b.text))) {
            return (react_1.default.createElement(styles_1.StyledSub, { style: shouldApplyBold ? { fontWeight: 'bold' } : { fontWeight: 'normal' } }, children.content.text));
        }
        const content = (react_1.default.createElement(rich_content_element_1.RichContentElement, { bold: shouldApplyBold, italic: shouldBeItalic, path: `${path}.content`, color: color, fontSize: fontSize }, children.content));
        return Object.keys(types_1.SemanticAttributes).reduce((acc, key) => {
            const shouldApply = children[key] === true || children[key] === 'true';
            if (shouldApply) {
                const SemanticElement = SEMANTIC_ATTRIBUTES_TAG[types_1.SemanticAttributes[key]];
                return react_1.default.createElement(SemanticElement, null, acc);
            }
            return acc;
        }, content);
    }
    catch (_c) {
        return null;
    }
};
exports.RichContentSemantic = RichContentSemantic;
